import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function Projects() {
  return (
    <>
     <Navbar />
     <Footer />
    </>
  )
}

export default Projects